export default __webpack_public_path__ + "static/media/react-logo.0cfa01a3.png";